import styled from "styled-components";

export const Legend = styled.legend`
    font: normal normal normal 14px/20px Circular Std Book;
    color: #454546;
    margin-bottom: 20px;
`


export const ContainerButton = styled.div`
    margin-top: 42px;
    
    @media(max-width: 500px){
        margin-bottom: 40px;
    }
`